export const INFLOW = "#10B981";
export const OUTFLOW = "#EF4444";
export const DEM = "#3B82F6";
export const GOP = "#F87171";
export const PRICE = "#A1A1AA";
export const SENT = "#93C5FD";
export const VOLUME = "#52525B";
export const GRID = "var(--hoip-divider)";
export const AXIS = "var(--hoip-text-tertiary)";

export const tooltipBox = {
  background: "var(--hoip-card)",
  border: "1px solid var(--hoip-border)",
  fontSize: 10,
  fontFamily: "JetBrains Mono, monospace",
  color: "var(--hoip-text-primary)",
};

export function compactUsd(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v === 0) return "$0";
  const sign = v < 0 ? "−" : "";
  const a = Math.abs(v);
  if (a >= 1e9) return `${sign}$${(a / 1e9).toFixed(1)}B`;
  if (a >= 1e6) return `${sign}$${(a / 1e6).toFixed(1)}M`;
  if (a >= 1e3) return `${sign}$${(a / 1e3).toFixed(0)}K`;
  return `${sign}$${a.toFixed(0)}`;
}

export function compactShares(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  if (Math.abs(v) >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (Math.abs(v) >= 1e3) return `${(v / 1e3).toFixed(0)}K`;
  return String(Math.round(v));
}

export function fmtMd(iso) {
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00Z`);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
}

export const STOCK_ACT_BRACKETS = [
  { label: "$1,001–$15,000", mid: 8000 },
  { label: "$15,001–$50,000", mid: 32500 },
  { label: "$50,001–$100,000", mid: 75000 },
  { label: "$100,001–$250,000", mid: 175000 },
  { label: "$250,001–$500,000", mid: 375000 },
  { label: "$500,001–$1,000,000", mid: 750000 },
  { label: "$1,000,001–$5,000,000", mid: 3000000 },
  { label: "$5,000,001–$25,000,000", mid: 15000000 },
  { label: "$25,000,001–$50,000,000", mid: 37500000 },
];
